import { render } from "./Downloads.vue?vue&type=template&id=2542ccd6&scoped=true"
import script from "./Downloads.vue?vue&type=script&lang=js"
export * from "./Downloads.vue?vue&type=script&lang=js"

import "./Downloads.vue?vue&type=style&index=0&id=2542ccd6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2542ccd6"

export default script